import { shape, string, arrayOf, number } from 'prop-types';

export default shape({
  id: number.isRequired,
  jobId: number.isRequired,
  name: string,
  status: string.isRequired,
  type: string,
  created: string,
  scheduled: string,
  updated: string,
});